// 手机展示指令
import { Common } from '@/utils/common';
export var mobile = function mobile(Vue) {
  Vue.directive('mobile', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function inserted(el, binding) {
      if (binding.value && Common.isMobile) {// 指定手机模式下插入
      } else if (!binding.value && !Common.isMobile) {// 指定非手机模式下插入
      } else {
        // 其他情况不插入
        el.remove();
      }
    }
  });
};